import { a as attr } from "../../../../../chunks/attributes.js";
import "@sveltejs/kit/internal";
import "../../../../../chunks/exports.js";
import "../../../../../chunks/utils.js";
import "@sveltejs/kit/internal/server";
import "../../../../../chunks/state.svelte.js";
function _page($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let username = "";
    let password = "";
    $$renderer2.push(`<h1 class="heading">Logowanie</h1> <form class="form-group"><input type="text" name="username" placeholder="Login" class="form-control"${attr("value", username)}/> <input type="password" name="password" placeholder="Hasło" class="form-control"${attr("value", password)}/> <div class="place-end"><button type="submit" class="btn">Zaloguj</button></div></form>`);
  });
}
export {
  _page as default
};
